export const baseUri = `/authentication`;
export const authorizationUri = `${baseUri}/authorization`;
export const realEstateAgentLoginUri = `${baseUri}/real-estate-agent/login`;
export const logoutUri = `${baseUri}/logout`;
